// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"7aecb39d","699":"4732a5ff"}[chunkId] + ".chunk.js";
};